// extracted by mini-css-extract-plugin
export default {"container":"Divider_container__C74Ut","designMode":"Divider_designMode__bx8Bi","empty":"Divider_empty__52guc"};